import { render, staticRenderFns } from "./MintalMesPrdShiftHandoverEdit.vue?vue&type=template&id=32e3de6c&"
import script from "./MintalMesPrdShiftHandoverEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdShiftHandoverEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports